/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {Element, Link, ScrollElement, scroller, scrollSpy} from 'react-scroll';

import {SetupGuideContext, Step} from '../types';
import styles from '../index.module.styl';

const SCROLL_CONTAINER_ID = `scrollable`;

export const scrollToStep = (step: Step) => {
  scroller.scrollTo(step, {
    duration: 1000,
    delay: 0,
    smooth: `easeInOutQuart`,
    containerId: SCROLL_CONTAINER_ID,
  });
};

export const Scrollable = ({children, className}) => {
  return (
    <div className={className} id={SCROLL_CONTAINER_ID}>
      {children}
    </div>
  );
};

const Element = (props) => {
  const {active, children, parentBindings, ...rest} = props;
  return (
    <div {...rest} style={{opacity: active ? 1 : 0.2}}>
      {children}
    </div>
  );
};

export const ScrollableElement = ScrollElement(Element);

export const ScrollableLink = (props) => {
  const {step, setStep: updateStep} = React.useContext(SetupGuideContext);

  const {targetStep, children, ...rest} = props;

  // Note - somewhat hacky way to enforce link update at initial render
  // spy seems to be firing before the link is mounted, so we need to
  // force an update after the first render
  const linkRef = React.useRef(false);
  React.useEffect(() => {
    if (linkRef.current === false && step !== null) {
      scrollSpy.update();
      linkRef.current = true;
    }
  }, [step]);

  return (
    <Link
      activeClass={styles.current}
      onSetActive={() => updateStep(targetStep)}
      to={targetStep}
      spy={true}
      containerId={SCROLL_CONTAINER_ID}
      {...rest}
    >
      {children}
    </Link>
  );
};
